module services {
    export module tariff {
        export class authorisedDealerService implements interfaces.tariff.IAuthorisedDealerService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all TariffCountry for a dropdown/autocomplete list
            getDropdownList(countryId: number): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "AuthorisedDealer/GetForDropdown", {
                    countryId: countryId
                });
            }
        }
    }
    angular.module("app").service("authorisedDealerService", services.tariff.authorisedDealerService);
}